module.exports = __webpack_public_path__ + "static/media/img_1-4_232insig.90282b80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/img_1-4_232insig.svg
// module id = 676
// module chunks = 0